<template>
  <div>
    <router-view />
  </div>
</template>
<script>
export default {
  name: "Lotteries",
  data() {
    return {};
  },
};
</script>
